<template>
    <div class="modal fade show custom-modal" :class="{'modal-show':showRidChangeConfirmationModal}">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header header-rid-bg">
                    <h4 class="modal-title title-rid-bg ml-3 mb-1">Risk Inception Date Changed</h4>
                    <button id="close_button" type="button" class="close mt-" @click="closeModal()">&times;</button>
                </div>
                <div class="modal-head">
                    <div class="text-center">
                        <img src="@/assets/images/danger.png" width="100px" class="mt-3"/>
                    </div>
                </div>
                <div class="text-center my-2 py-2">
                    <p class="title-rid-bg">Previous Risk Inception Date : <span class="rid-pin-date">{{ oldPinRid }}</span></p>
                    <p class="title-rid-bg">Current Risk Inception Date : <span class="rid-pin-date">{{ currentPinRid }}</span></p>
                </div>
                <div class="modal-footer mx-4 mb-2">
                    <button type="button" class="bgc-btn-primary mx-auto"
                    @click="closeModal()">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { reactive, computed } from '@vue/composition-api';
import functions from '@/../../masters/functions.js';

export default {
  name: "RidChangeConfirmationModal",
  props:['showRidChangeConfirmationModal','oldPinRid','policyInceptionData'],
  components: {
  },
  setup(props,context){
    let state = reactive({
    });
    function closeModal(){
        context.parent.callSaveQuoteOnPinRidModal();
    }
    const currentPinRid = computed(()=>{
        return functions.dateObjFormated(props.policyInceptionData.registrationDate.value);
    })
    return{
        closeModal,
        currentPinRid
    }
  }
};
</script>

<style scoped>
.custom-modal{
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0,0,0,0.4);
    transform:scale(0);
}
.modal-show{
    display:block;
    transform:scaleY(0) scaleX(0);
    animation:unfoldIn 0.25s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards;
}
.header-rid-bg{
    background: #FFFFC5;
}
.title-rid-bg{
    font-weight: 600;
}
.rid-pin-date{
    font-size: 18px;
    color: #007bff;
}
</style>